import "./carousel.css"
import React, { useState, useEffect} from 'react';

const UncontrolledExample = (props) => {
	const [currentSlide, setCurrentSlide] = useState(0);
	const [containerHeight, setContainerHeight] = useState('auto');
	
	// Generate unique carousel ID for this instance
	const carouselId = props.carouselId || 'carousel';
	
	const goToSlide = (slideIndex) => {
		setCurrentSlide(slideIndex);
	};
	
	const goToPrevious = () => {
		setCurrentSlide(prev => prev === 0 ? props.controls.length - 1 : prev - 1);
	};
	
	const goToNext = () => {
		setCurrentSlide(prev => prev === props.controls.length - 1 ? 0 : prev + 1);
	};
	
	// Handle image load to adjust container height
	const handleImageLoad = (e) => {
		const img = e.target;
		const aspectRatio = img.naturalHeight / img.naturalWidth;
		const containerWidth = img.parentElement.offsetWidth;
		const calculatedHeight = containerWidth * aspectRatio;
		setContainerHeight(`${calculatedHeight}px`);
	};
	
    return (
    // <div className="carousel">
	    <div className="carousel-inner" data-carousel-id={carouselId} style={{height: containerHeight}}>
	    
	        {props.controls.map((item,index) => (
	        	<img 
	        		key={`item-${index}`}
	        		className="carousel-item" 
	        		src={item.src} 
	        		alt={`Carousel image ${index + 1}`}
	        		style={{ opacity: currentSlide === index ? 1 : 0 }}
	        		onLoad={handleImageLoad}
	        	/>
   			))}
   			<span 
   				className="carousel-control prev" 
   				onClick={goToPrevious}
   				aria-label="Previous image"
   			>
   				<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
   					<path fill="transparent" stroke="hsl(0, 0%, 100%)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M22.5 12.5 15 20l7.5 7.5"/>
   				</svg>
   			</span>
   			<span 
   				className="carousel-control next" 
   				onClick={goToNext}
   				aria-label="Next image"
   			>
   				<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
   					<path fill="transparent" stroke="hsl(0, 0%, 100%)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.5 12.5 25 20l-7.5 7.5"/>
   				</svg>
   			</span>

	        {/*<label for="carousel-3" className="carousel-control prev control-1">◀︎</label>
	        <label for="carousel-2" className="carousel-control next control-1">▶︎</label>
	        <label for="carousel-1" className="carousel-control prev control-2">◀︎</label>
	        <label for="carousel-3" className="carousel-control next control-2">▶︎</label>
	        <label for="carousel-2" className="carousel-control prev control-3">◀︎</label>
	        <label for="carousel-1" className="carousel-control next control-3">▶︎</label>*/}
	        <ol className="carousel-indicators">
		        {props.controls.map((item,index) => (
		        	<li key={`indicator-${index}`}>
		                <button 
		                	className={`carousel-bullet ${currentSlide === index ? 'active' : ''}`}
		                	onClick={() => goToSlide(index)}
		                	aria-label={`Go to image ${index + 1}`}
		                >
		                	•
		                </button>
		            </li>
	   			))}
	           {/* <li>
	                <label for="carousel-1" className="carousel-bullet">•</label>
	            </li>
	            <li>
	                <label for="carousel-2" className="carousel-bullet">•</label>
	            </li>
	            <li>
	                <label for="carousel-3" className="carousel-bullet">•</label>
	            </li>*/}
	        </ol>
	    </div>
	// </div>
  )
};


export default UncontrolledExample;